import { startOfMonth, endOfMonth, eachDayOfInterval, format, isSameMonth, isToday, isSameDay } from 'date-fns';

export function getMonthDays(date: Date): Date[] {
  const start = startOfMonth(date);
  const end = endOfMonth(date);
  return eachDayOfInterval({ start, end });
}

export function getCalendarDays(date: Date): (Date | null)[] {
  const monthDays = getMonthDays(date);
  const firstDay = monthDays[0];
  const lastDay = monthDays[monthDays.length - 1];
  
  const startPadding = firstDay.getDay();
  const endPadding = 6 - lastDay.getDay();
  
  const paddedDays: (Date | null)[] = [];
  
  // Add padding for start of month
  for (let i = 0; i < startPadding; i++) {
    paddedDays.push(null);
  }
  
  // Add actual month days
  paddedDays.push(...monthDays);
  
  // Add padding for end of month
  for (let i = 0; i < endPadding; i++) {
    paddedDays.push(null);
  }
  
  return paddedDays;
}

export function formatDateKey(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function getDaysUntilInterviewSeason(): number {
  const today = new Date();
  const interviewSeasonStart = new Date(2026, 0, 1); // January 1, 2026
  const diffTime = interviewSeasonStart.getTime() - today.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export { format, isSameMonth, isToday, isSameDay };